import { ListItemWrapper } from '@inbox-demo-nx/ui-chat-common';
import { ComponentProps } from 'react';

import ChannelListItem from './ChannelListItem';

export default function ResponsiveChannelListItem(
  props: ComponentProps<typeof ChannelListItem>
) {
  return (
    <ListItemWrapper>
      <ChannelListItem {...props} />
    </ListItemWrapper>
  );
}
